import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import WaitlistForm from "./WaitlistForm";
import { useSettings } from "../context/SettingsContext";

export default function Footer() {
    const { settings } = useSettings();
    const hiddenPages = settings.hidden_pages || [];
    return (
        <footer className="border-t border-black/[0.06] mt-32 relative z-10" data-testid="site-footer">
            <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 grid md:grid-cols-5 gap-12">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-4 mb-6">
                        <img
                            src="/brand/logo.png"
                            alt="Art N Moore logo"
                            className="w-28 h-28 object-contain shrink-0"
                            data-testid="footer-logo-mark"
                        />
                        <div>
                            <div className="font-wordmark text-4xl font-medium text-[#1A1A1A] leading-none">
                                Art N Moore
                            </div>
                            <div className="mt-2 font-signature text-xl text-[#1A1A1A]">By Nick Moore</div>
                        </div>
                    </div>
                    <p className="text-[#5A5A5A] leading-relaxed max-w-md text-sm mb-8">
                        Original artworks and fine art prints — male portraits in charcoal, coloured pencil, and
                        photorealistic acrylic. A quiet, unapologetic study of the male form through a gay visual lens.
                    </p>
                    <WaitlistForm source="general" variant="footer" placeholder="Your email" cta="Join" />
                    <p className="mt-3 text-xs text-[#8A8A8A] leading-relaxed max-w-sm">
                        Hear first about new drops and rereleases of popular prints. No noise.
                    </p>
                </div>
                <div>
                    <div className="label-caps mb-4">Explore</div>
                    <ul className="space-y-3 text-sm text-[#5A5A5A]">
                        {!hiddenPages.includes("gallery") && <li><Link to="/gallery" className="hover:text-[#1A1A1A] transition-colors">Prints</Link></li>}
                        {!hiddenPages.includes("originals") && <li><Link to="/originals" className="hover:text-[#1A1A1A] transition-colors">Originals</Link></li>}
                        {!hiddenPages.includes("commissions") && <li><Link to="/commissions" className="hover:text-[#1A1A1A] transition-colors">Commissions</Link></li>}
                        {!hiddenPages.includes("about") && <li><Link to="/about" className="hover:text-[#1A1A1A] transition-colors">About</Link></li>}
                    </ul>
                </div>
                <div>
                    <div className="label-caps mb-4">Policies</div>
                    <ul className="space-y-3 text-sm text-[#5A5A5A]" data-testid="footer-policies">
                        <li><Link to="/policies" className="hover:text-[#1A1A1A] transition-colors">Shipping & Returns</Link></li>
                        <li><Link to="/privacy" className="hover:text-[#1A1A1A] transition-colors">Privacy</Link></li>
                        <li><Link to="/terms" className="hover:text-[#1A1A1A] transition-colors">Terms of Service</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-caps mb-4">Follow</div>
                    <a
                        href="https://instagram.com/Nick_Moore"
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-2 text-sm text-[#5A5A5A] hover:text-[#1A1A1A]"
                        data-testid="instagram-link"
                    >
                        <Instagram className="w-4 h-4" /> @Nick_Moore
                    </a>
                </div>
            </div>
            <div className="border-t border-black/[0.04] py-6 text-center text-xs text-[#8A8A8A] tracking-widest uppercase">
                © {new Date().getFullYear()} Art N Moore — Works by Nick Moore
            </div>
        </footer>
    );
}
